import { SELECTABLE_OFFER_PROVIDERS } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const disconnectOfferNetwork = {
  name: "disconnectOfferNetwork" as const,
  input: z.object({ provider: createEnum([...SELECTABLE_OFFER_PROVIDERS]) }),
  output: z.object({ success: z.boolean() }),
};
